module.exports = __webpack_public_path__ + "static/media/makecomma.3ff61d09.png";